var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43899 11.4066H3.29795C3.03109 11.4066 2.81471 11.6229 2.81471 11.8898C2.81471 12.1566 3.03109 12.373 3.29795 12.373H6.43846C6.70531 12.373 6.92169 12.1566 6.92169 11.8898C6.92169 11.6229 6.70585 11.4066 6.43899 11.4066Z",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53386 6.54358H3.29848C3.03163 6.54358 2.81525 6.75996 2.81525 7.02681C2.81525 7.29367 3.03163 7.51005 3.29848 7.51005H9.53332C9.80018 7.51005 10.0166 7.29367 10.0166 7.02681C10.0166 6.75996 9.80072 6.54358 9.53386 6.54358Z",
    fill: "#939393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53386 8.9748H3.29848C3.03163 8.9748 2.81525 9.19118 2.81525 9.45804C2.81525 9.72489 3.03163 9.94127 3.29848 9.94127H9.53332C9.80018 9.94127 10.0166 9.72489 10.0166 9.45804C10.0166 9.19118 9.80072 8.9748 9.53386 8.9748Z",
    fill: "#939393"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7273 0H4.93075C4.09421 0 3.41339 0.682439 3.41339 1.52166V2.91553H2.01844C1.18137 2.91553 0.5 3.5969 0.5 4.43397V14.4821C0.5 15.3192 1.18137 16 2.01844 16H10.8134C11.6504 16 12.3313 15.3192 12.3313 14.4821V13.0839H13.7273C14.5644 13.0839 15.2447 12.4031 15.2447 11.5666V1.5222C15.2447 0.682976 14.5644 0 13.7273 0ZM11.3648 14.4826C11.3648 14.7865 11.1173 15.0341 10.8134 15.0341H2.01844C1.714 15.0341 1.46648 14.7865 1.46648 14.4826V4.43397C1.46648 4.12953 1.714 3.88201 2.01844 3.88201H10.8134C11.1173 3.88201 11.3648 4.12953 11.3648 4.43397V14.4826ZM14.2787 11.5676C14.2787 11.8764 14.0366 12.1185 13.7278 12.1185H12.3318V4.43397C12.3318 3.5969 11.651 2.91553 10.8139 2.91553H4.3804V1.5222C4.3804 1.21615 4.62739 0.966475 4.93129 0.966475H13.7278C14.0317 0.966475 14.2787 1.21561 14.2787 1.5222V11.5676Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7df7cc12565a75f7a00e54264888567b.svg";
export { ForwardRef as ReactComponent };